import React from 'react';

class RoleCancelSubmit extends React.Component {
  render() {
    const { isNewRole } = this.props;
    return (
      <span className="pull-right">
        <button
          onClick={this._onClickCancel}
          className="btn btn-default no-outline"
          type="button"
          style={{ 'margin-right': '10px' }}
        >
          Cancel
        </button>
        <button
          onClick={this.props.handleSubmit(this._onClickSubmit)}
          className="btn btn-primary no-outline"
          type="submit"
          disabled={this.props.disableSubmit}
        >
          {isNewRole ? 'Create' : 'Save'}
        </button>
      </span>
    );
  }

  _onClickCancel = e => {
    e.stopPropagation();
    this.props.closeRightColumn();
  };

  _onClickSubmit = values => {
    this.props.onSubmit(values, this.props.isNewRole);
  };
}

export default RoleCancelSubmit;
